import { render, staticRenderFns } from "./PayUCheckoutForm.vue?vue&type=template&id=156c3737&scoped=true"
import script from "./PayUCheckoutForm.vue?vue&type=script&lang=ts"
export * from "./PayUCheckoutForm.vue?vue&type=script&lang=ts"
import style0 from "./PayUCheckoutForm.vue?vue&type=style&index=0&id=156c3737&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "156c3737",
  null
  
)

export default component.exports